import { useIdleTimer } from 'react-idle-timer';
import { Auth } from 'aws-amplify'; // v6 syntax (adjust for v5 if needed)
import { useNavigate } from 'react-router-dom';

const InactivityLogout = () => {
  const navigate = useNavigate();

  const handleOnIdle = async () => {
    console.log('User is idle. Logging out...');
    
    try {
      // 1. Clear Amplify Session
      await Auth.signOut(); 
      
      // 2. Clear any application specific state here
      // localStorage.removeItem('my_app_data');

      // 3. Redirect to login
      navigate('/login');
      alert("You have been logged out due to inactivity.");
    } catch (error) {
      console.error('Error signing out: ', error);
    }
  }

  const { getRemainingTime } = useIdleTimer({
    timeout: 1000 * 60 * 20, // 20 minutes in milliseconds
    onIdle: handleOnIdle,
    debounce: 500, // Wait 500ms after event to reset timer (performance)
    crossTab: true, // Syncs across tabs!
    leaderElection: true, // Only one tab handles the timeout
  });

  return null
}

export default InactivityLogout;